import { trpc } from '@/lib/trpc';
import type { ObservabilityFilters } from '../../../shared/types';

const STALE = 5 * 60 * 1000;

export const useObsOverview = () =>
  trpc.observability.overview.useQuery(undefined, { staleTime: STALE });

export const useObsCostBySource = (f: ObservabilityFilters = {}) =>
  trpc.observability.costBySource.useQuery(f, { staleTime: STALE });

export const useObsCostByVendor = (f: ObservabilityFilters = {}) =>
  trpc.observability.costByVendor.useQuery(f, { staleTime: STALE });

export const useObsCostByArea = (f: ObservabilityFilters = {}) =>
  trpc.observability.costByArea.useQuery(f, { staleTime: STALE });

export const useObsCostByUser = (f: ObservabilityFilters = {}) =>
  trpc.observability.costByUser.useQuery(f, { staleTime: STALE });

export const useObsAdoptionByUser = (f: ObservabilityFilters = {}) =>
  trpc.observability.adoptionByUser.useQuery(f, { staleTime: STALE });

export const useObsAdoptionByArea = (f: ObservabilityFilters = {}) =>
  trpc.observability.adoptionByArea.useQuery(f, { staleTime: STALE });

/** Nuestro MCP del Brain (corte por canal de lib/internal-brain-adoption.ts). */
export const useObsBrainMcp = (days: BedrockWindowDays) =>
  trpc.observability.brainMcp.useQuery({ days }, { staleTime: STALE });

export const useObsClaudeCode = (f: ObservabilityFilters = {}) =>
  trpc.observability.claudeCode.useQuery(f, { staleTime: STALE });

export const useObsGeminiActive = (f: ObservabilityFilters = {}) =>
  trpc.observability.geminiActive.useQuery(f, { staleTime: STALE });

export const useObsOptimization = () =>
  trpc.observability.optimizationFindings.useQuery(undefined, { staleTime: STALE });

export const useObsEBITDA = (f: ObservabilityFilters = {}) =>
  trpc.observability.ebitdaAllocation.useQuery(f, { staleTime: STALE });

export type { BedrockWindowDays } from '../../../shared/bedrock-features';
import type { BedrockWindowDays } from '../../../shared/bedrock-features';

export const useObsBedrockSummary = (days?: BedrockWindowDays) =>
  trpc.observability.bedrockSummary.useQuery(days ? { days } : undefined, { staleTime: STALE });

export const useObsBedrockByUser = (days?: BedrockWindowDays) =>
  trpc.observability.bedrockByUser.useQuery(days ? { days } : undefined, { staleTime: STALE });

export const useObsBedrockDaily = (days: BedrockWindowDays) =>
  trpc.observability.bedrockDaily.useQuery({ days }, { staleTime: STALE });

export const useObsBedrockReal = (days: BedrockWindowDays) =>
  trpc.observability.bedrockReal.useQuery({ days }, { staleTime: STALE, refetchOnWindowFocus: false });

export const useObsAwsCosts = (days?: BedrockWindowDays) =>
  trpc.observability.awsCosts.useQuery(days ? { days } : undefined, { staleTime: 24 * 60 * 60 * 1000, refetchOnWindowFocus: false });
